import { Loader } from '../loader/Loader';
import logo from '../../assets/imgs/brda_logo_light.svg';
import { useEffect } from 'react';

const OpeningAnimation = ({
  isOpen,
  isInitial,
}: {
  isOpen: boolean;
  isInitial: boolean;
}) => {
  useEffect(() => {
    let time: any = undefined;
    if (isOpen) {
      if (isInitial) {
        time = setTimeout(() => document.body.classList.add('lock_scroll'), 0);
      } else {
        document.body.classList.add('lock_scroll')
      }
    } else {
      document.body.classList.remove('lock_scroll');
    }

    // Cleanup function to remove the class when the component is unmounted
    return () => {
      if (isInitial) {
        clearTimeout(time);
      }

      document.body.classList.remove('lock_scroll');
    };
  }, [isOpen, isInitial]);

  return (
    <>
      {isOpen && (
        <div className='opening opening_animation'>
          <div id='animationLogo' className='opening_logo'>
            <img src={logo} alt='logo animated' loading='eager' />
            <Loader />
          </div>
        </div>
      )}
    </>
  );
};

export default OpeningAnimation;
